module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-529.d55b2ee5.jpg";